import { ButtonGroup } from "@material-ui/core";
import React from "react";

export const BUTTON_GROUP_SELECTED_CLASS = "bg-main-dark text-white";

export default function TSButtonGroup({ ...rest }) {
    return <ButtonGroup {...rest}></ButtonGroup>;
}
